var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block" }, [
    _c("h1", { staticClass: "pr-2 block-item" }, [
      _c(
        "a",
        {
          attrs: {
            href: "https://github.com/maple3142/apps-script-db",
            target: "_blank"
          }
        },
        [_vm._v(_vm._s(_vm.$t("appname")))]
      ),
      _vm._v(" " + _vm._s(_vm.$t("editor")))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "block-item" },
      [_c("loading", { attrs: { loading: _vm.$store.state.loading } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5cec328", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5cec328","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppName.vue
// module id = 33
// module chunks = 1